import { render } from "./PasswordReset.vue?vue&type=template&id=37a1bace&scoped=true"
import script from "./PasswordReset.vue?vue&type=script&lang=js"
export * from "./PasswordReset.vue?vue&type=script&lang=js"

import "./PasswordReset.vue?vue&type=style&index=0&id=37a1bace&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-37a1bace"

export default script